import React from 'react'
import { Holder } from '../Holder'
import { Locations } from 'EstraSuppliers'
import { useFormikContext } from 'formik'
import { ProfileFormValues } from '../../utils'
import { SmartCheckbox } from 'app/components/formik/Checkbox'
import { FormGroup } from 'app/components/shared/FormGroup'
interface Props {
  locations: Locations
  checkboxText: string
  holderWho: keyof Pick<
    ProfileFormValues,
    'technical_director_address' | 'technical_manager_address'
  >
  checkboxFor: keyof Pick<
    ProfileFormValues,
    'fill_technical_director' | 'fill_technical_manager'
  >
}
export const HolderWrapper: React.FC<Props> = ({
  locations,
  checkboxText,
  holderWho,
  checkboxFor,
}) => {
  const {
    values,
    //  setValues
  } = useFormikContext<ProfileFormValues>()

  // const checkboxFill = values[checkboxFor]
  // empty data when card is hidden
  // useEffect(() => {
  //   if (!checkboxFill) {
  //     setValues({
  //       ...values,
  //       [holderWho]: holderEmptyValues,
  //     })
  //   }
  // }, [checkboxFill])

  return (
    <>
      <FormGroup>
        <SmartCheckbox reverseBehaviour name={checkboxFor}>
          {checkboxText}
        </SmartCheckbox>
      </FormGroup>
      {values[checkboxFor] && (
        <Holder holderWho={holderWho} locations={locations} />
      )}
    </>
  )
}
